/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="44" height="44.399" viewBox="0 0 44 44.399">
  <defs>
    <filter id="Path_1788" x="0" y="0" width="44" height="44.399" filterUnits="userSpaceOnUse">
      <feOffset dy="4" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="2" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
    </filter>
    <filter id="Path_1788-2" x="0" y="0" width="44" height="44.399" filterUnits="userSpaceOnUse">
      <feOffset dy="4" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="2" result="blur-2"/>
      <feFlood flood-opacity="0.161" result="color"/>
      <feComposite operator="out" in="SourceGraphic" in2="blur-2"/>
      <feComposite operator="in" in="color"/>
      <feComposite operator="in" in2="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Group_3076" data-name="Group 3076" transform="translate(6.5 2.5)">
    <g id="Group_3077" data-name="Group 3077">
      <g id="Group_3530" data-name="Group 3530">
        <g id="Group_3529" data-name="Group 3529">
          <g data-type="innerShadowGroup">
            <g transform="matrix(1, 0, 0, 1, -6.5, -2.5)" filter="url(#Path_1788)">
              <path id="Path_1788-3" data-name="Path 1788" d="M25.748,32.417l-8.592-3.656a4.043,4.043,0,0,0-3.225.026l-7.87,3.5A4.043,4.043,0,0,1,.375,28.589V5.418A4.043,4.043,0,0,1,4.418,1.375H27.332a4.043,4.043,0,0,1,4.043,4.043V28.7A4.044,4.044,0,0,1,25.748,32.417Z" transform="translate(6.13 1.13)" fill="#3582ce" stroke="#3582ce" stroke-miterlimit="10" stroke-width="1"/>
            </g>
            <path id="Path_1788-4" data-name="Path 1788" d="M25.748,32.417l-8.592-3.656a4.043,4.043,0,0,0-3.225.026l-7.87,3.5A4.043,4.043,0,0,1,.375,28.589V5.418A4.043,4.043,0,0,1,4.418,1.375H27.332a4.043,4.043,0,0,1,4.043,4.043V28.7A4.044,4.044,0,0,1,25.748,32.417Z" transform="translate(-0.375 -1.375)" fill="#3582ce"/>
            <g transform="matrix(1, 0, 0, 1, -6.5, -2.5)" filter="url(#Path_1788-2)">
              <path id="Path_1788-5" data-name="Path 1788" d="M25.748,32.417l-8.592-3.656a4.043,4.043,0,0,0-3.225.026l-7.87,3.5A4.043,4.043,0,0,1,.375,28.589V5.418A4.043,4.043,0,0,1,4.418,1.375H27.332a4.043,4.043,0,0,1,4.043,4.043V28.7A4.044,4.044,0,0,1,25.748,32.417Z" transform="translate(6.13 1.13)" fill="#fff"/>
            </g>
            <path id="Path_1788-6" data-name="Path 1788" d="M25.748,32.417l-8.592-3.656a4.043,4.043,0,0,0-3.225.026l-7.87,3.5A4.043,4.043,0,0,1,.375,28.589V5.418A4.043,4.043,0,0,1,4.418,1.375H27.332a4.043,4.043,0,0,1,4.043,4.043V28.7A4.044,4.044,0,0,1,25.748,32.417Z" transform="translate(-0.375 -1.375)" fill="none" stroke="#3582ce" stroke-miterlimit="10" stroke-width="1"/>
          </g>
        </g>
      </g>
      <path id="Path_1789" data-name="Path 1789" d="M18.975,12.66a.961.961,0,0,1,.925-.676,1.041,1.041,0,0,1,.961.676c.534,1.673,1.174,3.63,1.495,4.627a.993.993,0,0,0,.961.676h4.84a1.009,1.009,0,0,1,.6,1.815c-1.423,1.032-3.1,2.242-3.95,2.847a1,1,0,0,0-.356,1.139c.32,1,.961,2.954,1.495,4.591a1,1,0,0,1-1.53,1.139c-1.424-1.032-3.061-2.242-3.915-2.883a1.016,1.016,0,0,0-1.174,0c-.854.641-2.527,1.851-3.95,2.883a.961.961,0,0,1-1.139,0,1.09,1.09,0,0,1-.391-1.139c.569-1.637,1.174-3.594,1.53-4.591a1.068,1.068,0,0,0-.392-1.139c-.854-.605-2.491-1.815-3.915-2.847a.962.962,0,0,1-.356-1.1.983.983,0,0,1,.925-.712h4.876a.993.993,0,0,0,.961-.676c.32-1,.925-2.954,1.495-4.627" transform="translate(-4.292 -7.134)" fill="#fff" fill-rule="evenodd"/>
    </g>
  </g>
</svg>
`

const NavigatorLikedSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default NavigatorLikedSvg
